<template>
  <div class="home">
    <div class="banner">
      <img class="bgImg" src="../asset/aike/mbanner.png" alt="">
    </div>
      <div class="form" id="div1">
        <div class="title wow fadeInUp">
            {{$t('message').text0}}
        </div>
          <div class="content wow fadeInUp">
            <div class="item ">
              <input type="text" :placeholder="$t('message').text1" v-model="form.company">
            </div>
            <div class="item">
              <input type="text" :placeholder="$t('message').text2" v-model="form.description">
            </div>
            <div class="item">
              <input type="text" :placeholder="$t('message').text3" v-model="form.name">
            </div>
            <div class="item">
              <input type="text" :placeholder="$t('message').text4" v-model="form.telephone">
            </div>
            <div class="item">
              <input type="text" :placeholder="$t('message').text5" v-model="form.b_area">
            </div>
            <div class="item">
              <input type="text" :placeholder="$t('message').text6" v-model="form.s_area">
            </div>
            <div class="item2">
              <textarea :placeholder="$t('message').text7" v-model="form.content"></textarea>
            </div>

          </div>
        <div class="btn wow fadeInUp" @click="submitForm">
          {{$t('message').text8}}
        </div>
      </div>



    <foot></foot>
  </div>
</template>

<script>
import foot from "@/components/foot.vue";
import Scrollbar from 'smooth-scrollbar';
import  qs from 'qs'

export default {
  name: "home",
  data() {
    return {
        scrollbar:'',
      form:{
        company:'',
        description:'',
        name:'',
        telephone:'',
        b_area:'',
        s_area:'',
        content:''
      }
    };
  },
  mounted() {
      Scrollbar.initAll(document.getElementById("scroller-wrapper"));
      this.scrollbar = Scrollbar.get(document.getElementById("scroller-wrapper"));
      this.scrollbar.scrollTo(0, 1);
      this.scrollbar.addListener((status) => {
          window.pageYOffset = this.scrollbar.scrollTop;
      });
    setTimeout(()=>{
      Scrollbar.get(
              document.getElementById("scroller-wrapper")
      ).scrollIntoView(document.querySelector("#div1"), {
        offsetTop: 150
      });
    },100)
  },
  components: {foot},
  methods:{
    submitForm() {
      if (
              this.form.company == "" ||
              this.form.name == "" ||
              this.form.telephone == "" ||
              this.form.b_area == ""
      ) {
        this.$notify.info({
          title: "提示",
          message: "请将信息填写完整哦"
        });
      } else {
        this.$nextTick(() => {
          const url = "/common/Form.php";
          this.$axios
                  .post(url, qs.stringify(this.form))
                  .then(res => {
                    if (res.data.code === 200) {
                      this.$notify({
                        title: "成功",
                        message: "您的信息已经成功提交",
                        type: "success"
                      });
                      this.form = {
                        company:'',
                        description:'',
                        name:'',
                        telephone:'',
                        b_area:'',
                        s_area:'',
                        content:''
                      };
                    }
                  })
                  .catch(res => {
                    this.$notify.error({
                      title: "错误",
                      message: "提交失败"
                    });
                  });
        });
      }
    }
  }
};
</script>
<style  lang="scss" scoped>
.home{
  width:100%;
  .banner{
    width:100%;
    height:100vh;
      position: relative;
    overflow: hidden;
    .bgImg{
      width:100%;
      display: block;
      object-fit: cover;
      height:100%;
      animation: sbig 5s linear forwards;
    }
    @keyframes sbig {
      from{
        transform: scale(1);
      }
      to{
        transform: scale(1.05);
      }
    }
  }
  .form{
    width:70%;
    margin: 60px auto;
    padding-bottom: 80px;
    .title{
      text-align: center;
      font-size: 38px;
      font-family: "SOURCEHANSANSCN-BOLD";
      animation-duration: 2s;
    }
    .content{
       display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
      margin: 60px auto;
      margin-bottom: 30px;
      animation-duration: 2s;
      .item{
        width:49%;
        margin-bottom: 30px;
        input{
          background-color: #F9F9F9;
          width:100%;
          height:62px;
          line-height: 62px;
          text-indent: 20px;
          color:#666666;
          font-family: "SOURCEHANSANSCN-MEDIUM";
          border: none;
          outline: none;
        }
      }
      .item2{
        width:100%;
        textarea{
          background-color: #F9F9F9;
          width:100%;
          height:300px;
          line-height: 62px;
          text-indent: 20px;
          color:#666666;
          font-family: "SOURCEHANSANSCN-MEDIUM";
          border: none;
          outline: none;
          resize: none;
        }
      }

    }
    .btn{
      width:271px;
      height:55px;
      border: 1px solid #019bdb;
      text-align: center;
      line-height: 55px;
      font-family: "SOURCEHANSANSCN-REGULAR";
      cursor: pointer;
      transition: all 600ms;
      position: relative;
      float: right;
      animation-duration: 2s;
      &::after{
        position: absolute;
        top: 0;
        left: 0;
        display: inline-block;
        content: "";
        background-color: #019bdb;
        width: 0;
        height: 100%;
        -webkit-transition: all 600ms;
        transition: all 600ms;
        z-index: -1;
      }
      &:hover{
        color:white;
        &::after{
          width:100%;
        }
      }
    }
  }
  @media screen and (max-width: 1000px){
    .form{
      width:90%;
      margin: 30px auto;
      .title{
        font-size: 24px;
      }
      .content{
        margin: 30px auto;
        .item{
          width:100%;
        }
        .item2{
          textarea{
            height: 200px;
          }
        }
      }
      .btn{
        width:160px;
        line-height: 40px;
        height: 40px;
      }
    }
  }
}
</style>
